"use client";

import { regFlow, sprFlow, sprWithJobIdFlow } from "@/constants/common";
import { getJobIdFromParams } from "@/helpers/jobs";
import { useMobile } from "@/hooks";
import { EventTrackingProps } from "@/types/common";
import dynamic from "next/dynamic";
import { useSearchParams } from "next/navigation";
import React, { useState } from "react";

import BasicHeader from "@/components/common/basicHeader";
import JobDetail from "@/components/single-page-registration/job-detail";
import ActionButtons from "@/components/single-page-registration/job-detail/common/ActionButtons";

type RegistrationComponentProps = {
  handleEventTracking: (props: EventTrackingProps) => void;
  flowType?: typeof regFlow | typeof sprFlow | typeof sprWithJobIdFlow;
  jobDetailUrlForSprWithId?: string;
};

type SinglePageRegProps = {
  hostname: string;
  handleEventTracking: (props: EventTrackingProps) => void;
};

const Registration = dynamic(
  () =>
    import("@monsterindia/registration").then(
      (mod) =>
        mod.Registration as unknown as React.FC<RegistrationComponentProps>,
    ),
  {
    ssr: false,
  },
);

const SinglePageRegistration: React.FC<SinglePageRegProps> = ({
  hostname,
  handleEventTracking,
}) => {
  const isMobile = useMobile();
  const searchParams = useSearchParams();
  const jobId = getJobIdFromParams(searchParams);

  const [isShowReg, setIsShowReg] = useState(false); // only for mobile view in single page registration with job id
  const [jobDetailUrl, setJobDetailUrl] = useState("");
  const setJobUrl = (url: string) => {
    // used to open job details page if on single-page-reg with job id user click on close button of registration
    setJobDetailUrl(url);
  };
  const handleShowReg = () => {
    setIsShowReg(true);
  };

  return jobId ? (
    <div className="grid h-[100svh] w-screen grid-rows-[auto_minmax(0,1fr)]">
      <BasicHeader isMobile={isMobile} hostname={hostname} />
      {!isShowReg ? (
        <>
          <div
            id="jobDetails"
            className={`box-border grid grid-cols-1 gap-6 md:grid-cols-3 ${!isMobile ? "pl-4" : ""}`}
          >
            <div className="scrollbar-hide col-span-2 h-full overflow-y-scroll md:py-4 lg:pl-20">
              <JobDetail
                isMobile={isMobile}
                setJobUrl={setJobUrl}
                hostname={hostname}
              />
            </div>
            {!isMobile && (
              <div className="col-span-1 h-full px-6 pt-4 shadow-2xl">
                <Registration
                  handleEventTracking={handleEventTracking}
                  flowType={sprWithJobIdFlow}
                  jobDetailUrlForSprWithId={jobDetailUrl}
                />
              </div>
            )}
          </div>
          {isMobile && <ActionButtons handleClick={handleShowReg} />}
        </>
      ) : (
        <Registration
          handleEventTracking={handleEventTracking}
          flowType={sprWithJobIdFlow}
        />
      )}
    </div>
  ) : (
    <Registration
      handleEventTracking={handleEventTracking}
      flowType={sprFlow}
    />
  );
};

export default SinglePageRegistration;
